
import { Component, Vue, Emit } from 'vue-property-decorator';
import { mixin as Clickaway } from 'vue-clickaway';

@Component({
  mixins: [ Clickaway ],
})

export default class NevronConfirmDelete extends Vue {
  confirm() {
    this.$emit('confirm');
  }
  cancel() {
    this.$emit('cancel');
  }
}
